import Select, {
    CSSObjectWithLabel,
    GroupBase,
    MenuPlacement,
    OptionsOrGroups,
} from "react-select";
import { Ref } from "react";
import { TOptions } from "@ts/common-types";

interface ISingleSelect {
    selectRef: Ref<null>;
    options: OptionsOrGroups<number, GroupBase<number>> | readonly TOptions[];
    /* 
  ! react-select gives object as data in this function as first arg but is asking to 
  ! keep the first arg as number in type def that's why any has been given here
 */
    handleChange: (newValue: any) => void;
    selectedValue: number;
    menuPlacement: MenuPlacement;
}

const SingleSelect = ({
    selectRef,
    options,
    handleChange,
    selectedValue,
    menuPlacement,
}: ISingleSelect) => {
    const customStyles = {
        control: (base: CSSObjectWithLabel) => ({
            ...base,
            backgroundColor: "transparent",
            border: "0 !important",
            boxShadow: "none",
            "&:hover": {
                border: "0 !important",
            },
        } as CSSObjectWithLabel),
        placeholder: (base: CSSObjectWithLabel) => {
            return {
                ...base,
                color: "black",
            } as CSSObjectWithLabel
        },
    };

    return (
        <>
            <Select
                placeholder={`Results per page: ${selectedValue}`}
                openMenuOnClick={true}
                ref={selectRef}
                options={options as OptionsOrGroups<number, GroupBase<number>>}
                value={selectedValue}
                onChange={handleChange}
                isSearchable={false}
                styles={customStyles}
                menuPlacement={menuPlacement}
            />
        </>
    );
};

export default SingleSelect;
